import Vue from 'vue'
import dayjs from 'dayjs'

Vue.mixin({
  methods: {
    goTo(url, params = {}) {
      this.$router.push({ name: url, params: params })
    },

    getDateToday() {
      let date = new Date()
      return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },

    parseDate(date, format = 'DD MMMM YYYY') {
      return dayjs(date).format(format)
    },

    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  },
  filters: {
    parseDate(date, format = 'DD MMMM YYYY') {
      return dayjs(date).format(format)
    },

    capitalize(str) {
      if (!str) return
      if (str.length === 1) return str.toUpperCase()
      let parsedStr = str.toString()
      return (
        parsedStr.charAt(0).toUpperCase() + parsedStr.slice(1).toLowerCase()
      )
    },

    price(n) {
      const formatNumber = v =>
        v.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      let value = (n || '0').toString()
      let decimalPos = value.indexOf('.')
      value = value.replace(/^\$0+/, '')
      if (decimalPos >= 0) {
        let decimal = value.substring(decimalPos).substring(0, 3)
        return `${formatNumber(value.substring(0, decimalPos))}${
          decimal.length >= 3 ? decimal : decimal + '0'
        }`
      } else {
        return `${formatNumber(value)}`
      }
    },

    tooLong(val, length = 200) {
      if (length < 3 || !val || val.length < length) return val
      return val.substring(0, length - 3) + '...'
    }
  }
})
